import { useSelector } from 'react-redux';
import Community from '../../types/community';
import { RootState } from '../../redux/reducer';
import { store } from '../../redux/store';

function useSelectedCommunity(): Community | undefined {
  const community = useSelector((state: RootState): Community | undefined =>
    state.application.communities?.find((x: Community): boolean => x.id === state.application.selectedCommunity),
  );

  return community;
}

export function getSelectedCommunity(): Community | undefined {
  return store
    .getState()
    .application.communities?.find((x: Community): boolean => x.id === store.getState().application.selectedCommunity);
}

export default useSelectedCommunity;
